export default __webpack_public_path__ + "static/media/profile_2.54068443.png";